<div class="copyright">
    <span class="muted">{{currentDate | date:'yyyy'}}©</span>&nbsp;DataBank,&nbsp;Ltd.
</div>
